var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.999 30H39.999V33.333H34.999V38.333H31.666V33.333H26.666V30H31.666V25H34.999V30ZM31.666 6.66602C32.5501 6.66602 33.3983 7.01746 34.0234 7.64258C34.6485 8.2677 34.999 9.11596 34.999 10V21.666H31.666V20H4.99902V30H23.333V33.333H4.99902C4.11514 33.3329 3.26758 32.9815 2.64258 32.3564C2.01759 31.7314 1.66608 30.8839 1.66602 30V10C1.66602 8.15016 3.14925 6.66628 4.99902 6.66602H31.666ZM4.99902 13.333H31.666V10H4.99902V13.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPlus);
export default __webpack_public_path__ + "static/media/credit-card-plus.d1ecda6d06207428554954c8a77cd273.svg";
export { ForwardRef as ReactComponent };